export enum GeoTargetType {
  Airport = 'Airport',
  Canton = 'Canton',
  'City Region' = 'City Region',
  City = 'City',
  Country = 'Country',
  County = 'County',
  District = 'District',
  Municipality = 'Municipality',
  Neighborhood = 'Neighborhood',
  'Postal Code' = 'Postal Code',
  Province = 'Province',
  Region = 'Region',
  State = 'State',
  Department = 'Department',
}

export type GeoTargetingData = {
  id: number;
  name: string;
  canonicalName: string;
  targetType: GeoTargetType;
  countryCode: string;
  parentId: number;
};
